<template>
  <a-modal :title="title" :width="900" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="10">
              <a-form-item label="样式名称">
                <a-input v-model="query.styleName" placeholder="样式名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item label="样式类型">
                <a-select v-model="query.styleType" placeholder="请选择" allow-clear>
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option :value="1">点</a-select-option>
                  <a-select-option :value="2">线</a-select-option>
                  <a-select-option :value="3">面</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="queryList">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table size="middle" rowKey="id"
        :row-selection="{ selectedRowKeys: this.selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
        :columns="columns" :loading="dataListLoading" :pagination="pagination" :scroll="{ y: 400 }"
        @change="pageChange">

        <div slot="stylePreview" slot-scope="text, record">
          <div v-if="record.styleType === 1"
            style="width:40px;height:40px;border-radius:4px;background:#ECEFF3;display:flex;justify-content: center;align-items: center;">
            <img :src="text" width="35" height="35" alt="图标" />
          </div>
          <div v-if="record.styleType === 2" style="width:50px;height:40px;">
            <svg style="width:100%; height:50%">
              <g fill="none" :stroke="text | lineStyle1">
                <path :stroke-width="text | lineStyle2" d="M0 10 l65 0" :stroke-dasharray='text | lineStyle3' />
              </g>
            </svg>
            <svg style="width:100%; height:50%" viewBox="-3 2 22 3">
              <g fill="none" :stroke="text | lineStyle1">
                <path d="M3,5 l1,-3 l1,3" :stroke-linejoin='text | lineStyle4' />
              </g>
            </svg>
          </div>
          <div v-if="record.styleType === 3" style="width:40px;height:40px;" :style="text | layerStyle"></div>
        </div>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    title: '样式名称',
    dataIndex: 'styleName'
  },
  {
    title: '样式类型',
    dataIndex: 'styleType',
    customRender: (text) => text === 1 ? '点' : (text === 2 ? '线' : '面')
  },
  {
    title: '预览',
    dataIndex: 'styleValue',
    scopedSlots: { customRender: 'stylePreview' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'StyleSelectModal',
  filters: {
    layerStyle: (value) => {
      if (!value) return '';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return `background:${arrs[0]};border:${arrs[1]} ${arrs[3]}px solid; opacity:${arrs[2]}; width:40px; height:40px;`
    },
    lineStyle1: (value) => {
      if (!value) return '#1890ff';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return arrs[1] || '#1890ff'
    },
    lineStyle2: (value) => {
      if (!value) return '2';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return arrs[0] || '2'
    },
    lineStyle3: (value) => {
      if (!value) return '0';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return arrs[2] || '0'
    },
    lineStyle4: (value) => {
      if (!value) return 'round';
      const arr = value.split(';')
      const arrs = []
      for (let i = 0; i < arr.length; i++) {
        const parts = arr[i].split(':');
        if (parts.length > 1) arrs.push(parts[1])
      }
      return arrs[3] || 'round'
    }
  },
  data () {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      columns,
      queryUrl: '/manager/base-style/page',
      query: {
        styleName: '',
        styleType: ''
      },
      title: '选择样式库',
      visible: false,
      confirmLoading: false
    }
  },
  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    show (arr) {
      this.visible = true
      this.queryList()
      this.$nextTick(() => {
        this.selectedRowKeys = arr || []
      })
    },
    handleCancel () {
      this.close()
    },
    close () {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    handleOk () {
      if (this.selectedRows.length > 0) {
        this.$emit('select', this.selectedRows[0])
      }
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
</style>
